module.exports = __webpack_public_path__ + "static/pedro-eb090c8b74143a82aac6e6ab75698866.png";